'use client';

import type { NavBar } from '@/api/types/navigationTypes';
import { AnonymousHeader } from '@/components/AnonymousHeader/AnonymousHeader';
import { AuthHeader } from '@/components/AuthHeader';
import { isUserAuthenticated } from '@/features/auth/client';

import { NavigationBar } from '../Navigation/NavigationBar';
import { TopRightNav } from '../Navigation/TopRightNav';

interface ConditionalHeaderProps {
  children?: React.ReactNode;
  brandIcon?: string;
  navBar?: NavBar;
  subNavBar?: NavBar;
}

export function ConditionalHeader({ navBar, subNavBar, ...rest }: ConditionalHeaderProps): React.ReactNode {
  const isAuthenticated = isUserAuthenticated();

  return isAuthenticated ? (
    <AuthHeader {...rest}>
      {navBar ? (
        <NavigationBar navBar={navBar}>
          <TopRightNav subNavBar={subNavBar} />
        </NavigationBar>
      ) : null}
    </AuthHeader>
  ) : (
    <AnonymousHeader {...rest}>{navBar ? <NavigationBar navBar={navBar} /> : null}</AnonymousHeader>
  );
}
